import styled from 'styled-components';
import { Colors } from '../../../theme';
export const InfoSection = styled('div')({
    flex: 1,
    paddingBottom: 8,
    marginBottom: 16,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${Colors.grey200}`,
});
export const MenuSection = styled('div')({
    flex: 1,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `solid 1px ${Colors.black40}`,
});
export const Wrapper = styled('div')({
    display: 'block',
    width: '100%',
});
//# sourceMappingURL=styles.js.map